import { Component,HostListener,ViewChild,ElementRef  } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { WpClientCode, WpPost, WpPostRequest, WpSectionCode } from '../../../services/http/wordpress/wordpress.interface';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-autorization-detail',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './autorization-detail.component.html',
  styleUrl: './autorization-detail.component.scss'
})
export class AutorizationDetailComponent {
  code = '';
  autorization: WpPost | undefined;
 
  constructor(
    private readonly activeRoute: ActivatedRoute,
    private readonly wordpressService: WordpressService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    this.code = this.activeRoute.snapshot.paramMap.get('code') || '';
    if (this.code) {
      this.wordpressService.getPosts({client: WpClientCode.genCat, section: WpSectionCode.autorizationType} as WpPostRequest).subscribe((response) => {
        this.autorization = response?.find((label) => label.acf.aluvisa_id === this.code);
      });
    }
  }

  async newAutorization() {
    if (this.authService.isAuthenticated()){
      if (this.code == 'TALLER') {
        this.code = 'MUNICIPAL';
      }
      this.router.navigate(['exceptions', 'new', 'new', this.code]);
    } else{
      if (this.code == 'FOREIGN') {
        this.router.navigate(['register-foreign']);
      }
      else {
        this.router.navigate(['login']);
      }
    }
  }
  
}
